import React from 'react';
import Gallery from '../../components/Gallery.js';
import TextBlockOben from '../../components/TextBlockOben.js';

const images = [
  {
    src: require('../../images/Strickereien_Handstulpen.png'),
    title: 'Handstulpen',
    caption: ''
  },
  {
    src: require('../../images/Sitzkissen_gestrickt.png'),
    title: 'gestrickte Stuhlauflagen',
    caption: ''
  },
];


const Strickereien = (props) => {
  console.log(images);
  return (
    <TextBlockOben>
            <h1>Strickereien</h1>
            <p>Ich stricke für Euch aus verschiedenen Garnen kleine Accessoires für den Alltag.</p>
            <p>Wenn Ihr mich und meine Produkte einmal vor Ort kennenlernen möchtet,<br />
               dann freue ich mich auf Euren Besuch an meinem Stand.</p>
        <Gallery images={images} />
    </TextBlockOben>
  );
}


export { Strickereien };
